/** Legacy example resumes use `example+*@kudoswall.com` emails. */
export function isExampleResumeEmail(email: string | null | undefined): boolean {
  if (!email) {
    return false;
  }
  return /^example\+.*@kudoswall\.com$/i.test(String(email).trim());
}

export function getResumeDisplayName(
  resume: { name?: string | null } | null | undefined,
): string {
  if (resume?.name && String(resume.name).trim()) {
    return String(resume.name).trim();
  }
  return 'this candidate';
}
